import React, { useEffect, useState } from "react";
import axios from "../../routers/axios";
import { motion, AnimatePresence } from "framer-motion";
import CreateReadingWritingModal from "./CreateReadingWritingModal";

const AddReadingWritingModal = ({ isOpen, onClose, scenarioId, onAdded }) => {
  const [activeTab, setActiveTab] = useState("reading");
  const [list, setList] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);

  useEffect(() => {
    if (isOpen) fetchList(activeTab);
  }, [isOpen, activeTab, scenarioId]);

  const fetchList = async (type) => {
    try {
      setLoading(true);
      const res = await axios.get(`/scenarios/${type}/list-all`);
      const data = res.data || [];

      // ✅ Tick sẵn nếu reading/writing đã thuộc scenario này
      const preSelected = data
        .filter(
          (item) =>
            item.scenario_id && Number(item.scenario_id) === Number(scenarioId)
        )
        .map((item) => item.id);

      setList(data);
      setSelectedIds(preSelected);

      console.log("✅ Dữ liệu:", data);
      console.log("✅ Đã tick sẵn:", preSelected);
    } catch (err) {
      console.error("Lỗi load danh sách:", err);
      setList([]);
    } finally {
      setLoading(false);
    }
  };

  const handleToggle = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleAdd = async () => {
    if (selectedIds.length === 0) {
      alert("Vui lòng chọn ít nhất một mục để thêm!");
      return;
    }
    try {
      const url = `/scenarios/${activeTab}/add-to-scenario`;

      await axios.post(url, {
        scenario_id: scenarioId,
        item_ids: selectedIds,
      });

      alert("✅ Đã thêm thành công!");
      onAdded && onAdded();
      onClose();
    } catch (err) {
      console.error("❌ Lỗi khi thêm:", err);
      alert("Lỗi khi thêm vào scenario.");
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 overflow-hidden"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="bg-white w-[90vw] max-w-6xl rounded-xl shadow-2xl overflow-hidden"
          >
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b">
              <h3 className="text-lg font-semibold">
                Thêm {activeTab === "reading" ? "Reading" : "Writing"} vào Scenario
              </h3>

              <div className="flex items-center gap-2">
                <button
                  onClick={() => setShowCreateModal(true)}
                  className="px-3 py-1.5 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                >
                  + Thêm mới {activeTab === "reading" ? "Reading" : "Writing"}
                </button>
                <button
                  onClick={onClose}
                  className="text-gray-500 hover:text-gray-700 text-xl leading-none"
                >
                  ✖
                </button>
              </div>
            </div>

            {/* Tabs */}
            <div className="flex border-b">
              {['reading', 'writing'].map((t) => (
                <button
                  key={t}
                  onClick={() => {
                    setActiveTab(t);
                    setSelectedIds([]);
                  }}
                  className={`px-4 py-2 font-medium transition-all ${activeTab === t
                    ? 'border-b-2 border-blue-600 text-blue-600'
                    : 'text-gray-500 hover:text-blue-600'
                    }`}
                >
                  {t === 'reading' ? 'Reading' : 'Writing'}
                </button>
              ))}
            </div>

            {/* Content */}
            <div className="p-4 max-h-[80vh] overflow-y-auto space-y-2">
              {loading ? (
                <p className="text-gray-500 text-center py-6">Đang tải dữ liệu...</p>
              ) : list.length > 0 ? (
                list.map((item) => (
                  <label
                    key={item.id}
                    className="flex items-center gap-3 border p-3 rounded-lg hover:bg-gray-50 cursor-pointer"
                  >
                    <input
                      type="checkbox"
                      checked={selectedIds.includes(item.id)}
                      onChange={() => handleToggle(item.id)}
                    />
                    <div>
                      <div
                        className="font-semibold text-gray-800"
                        dangerouslySetInnerHTML={{
                          __html:
                            item.reading_title ||
                            item.writing_title ||
                            item.title ||
                            `ID: ${item.id}`,
                        }}
                      />
                      <p className="text-sm text-gray-500">
                        {item.duration_minutes ? `${item.duration_minutes} phút` : ''}
                      </p>
                    </div>
                  </label>
                ))
              ) : (
                <p className="text-gray-500 text-center py-6">
                  Không có dữ liệu {activeTab}.
                </p>
              )}
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-3 p-4 border-t bg-gray-50">
              <button
                onClick={onClose}
                className="px-4 py-2 border rounded-lg hover:bg-gray-100"
              >
                Hủy
              </button>
              <button
                onClick={handleAdd}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
              >
                Thêm
              </button>
            </div>
          </motion.div>

          <CreateReadingWritingModal
            isOpen={showCreateModal}
            onClose={() => setShowCreateModal(false)}
            type={activeTab}
            onCreated={() => {
              fetchList(activeTab);
              setShowCreateModal(false);
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default AddReadingWritingModal;